import { useEffect, useState } from "react";

// Extend the Window interface to include google property
declare global {
  interface Window {
    // google?: {
    //   recaptcha: {
    //     reset(): void;
    //     setOnLoadCallback(callback: () => void): void;
    //   };
    // };
	google?: wts_approved_any;
    grecaptcha?: {
      reset(): void;
    };
  }
}

function useGoogleCaptcha(): Window['google'] | null {
  const [google, setGoogle] = useState<Window['google'] | null>(null);
    
    useEffect(() => {
        if (!google) {
			const head: HTMLHeadElement = document.head;
			let script: HTMLScriptElement | null = document.getElementById('googleCaptchaScript') as HTMLScriptElement;
			if (!script) {
				script = document.createElement('script');
				script.async = true;
				script.src = 'https://www.google.com/recaptcha/api.js';
				script.id = 'googleCaptchaScript';
				script.onload = (): void => {
					if (window.google && window.google.recaptcha) {
						if (window.grecaptcha) {
							window.grecaptcha.reset();
						}
						window.google.recaptcha.setOnLoadCallback(() => setGoogle(window.google || null));
					}
				};
				head.appendChild(script);
			} else if (window.google && window.google.recaptcha) {
				setGoogle(window.google);
			}
        }
		return (): void => {
			const script: HTMLElement | null = document.getElementById('googleCaptchaScript');
			if (script) {
			  script.remove();
			}
		  };
   }, [google]);

  return google;
}

export default useGoogleCaptcha;